// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2981":"cbd49cc0","4376":"cbd49cc0","4698":"cbd49cc0","4744":"cbd49cc0","7161":"cbd49cc0"}[chunkId] + ".chunk.css";
};